// Hardcoded exclusion rules applied to every user (in addition to user-specific
// exclusions from /product/exclusions). Centralized so every configurator
// surface applies the exact same set.
//
// label_id is read from localStorage at call time (set by label-switching code).

const buildRule = (overrides) => ({
    application: null,
    material: null,
    color: null,
    polish: null,
    coating: null,
    orientation: null,
    sterile: null,
    intendedUse: null,
    clinicalUse: null,
    custom: null,
    case: null,
    practitioner: null,
    isAllowed: false,
    ...overrides,
});

export const getHardcodedExclusions = () => {
    const labelId = window.localStorage.getItem("label_id");

    const rules = [
        // Medical + sterile is never allowed
        buildRule({ application: "Medical", sterile: true }),
        // Dental + sterile is never allowed
        buildRule({ application: "Dental", sterile: true }),
        // PA11 Blue should never appear in any configurator
        buildRule({ material: "Oceanz PA11 Blue" }),
    ];

    // No dental at all on YourOceanz (label_id === 2)
    if (labelId === "2" || labelId === 2) {
        rules.push(buildRule({ application: "Dental" }));
    }

    return rules;
};
